import script from "./CreatedProyect.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatedProyect.vue?vue&type=script&setup=true&lang=js"

import "./CreatedProyect.vue?vue&type=style&index=0&id=5e42c7b5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e42c7b5"]])

export default __exports__